import { subscriptionTypesMap } from '@/data/type-maps';
import { useAuthStore } from '@/stores/auth.ts';
export default {
    updated(el, binding) {
        restrict(el, binding);
    },
    beforeMount(el, binding) {
        restrict(el, binding);
    },
};
function restrict(el, binding) {
    if (shouldRestrict(binding)) {
        el.addEventListener('click', (event) => {
            event.stopPropagation();
            event.preventDefault();
        });
        if (el.firstChild) {
            el.firstChild.addEventListener('click', (event) => {
                event.stopPropagation();
                event.preventDefault();
            });
        }
        el.setAttribute('disabled', 'disabled');
    }
    else {
        el.removeAttribute('disabled');
    }
}
function shouldRestrict(binding) {
    var _a, _b, _c, _d, _e, _f, _g;
    const authStore = useAuthStore();
    if (authStore.user && ((_b = (_a = authStore.user) === null || _a === void 0 ? void 0 : _a.permissions) === null || _b === void 0 ? void 0 : _b.subscription.tag) === subscriptionTypesMap.free) {
        return true;
    }
    if ((binding === null || binding === void 0 ? void 0 : binding.arg) === 'waybill' && ((_d = (_c = authStore.user) === null || _c === void 0 ? void 0 : _c.permissions) === null || _d === void 0 ? void 0 : _d.subscription.tag) === subscriptionTypesMap.mini) {
        return true;
    }
    if ((binding === null || binding === void 0 ? void 0 : binding.arg) === 'work-act' && ((_f = (_e = authStore.user) === null || _e === void 0 ? void 0 : _e.permissions) === null || _f === void 0 ? void 0 : _f.subscription.tag) === subscriptionTypesMap.mini) {
        return true;
    }
    return Boolean(((_g = authStore.user) === null || _g === void 0 ? void 0 : _g.is_employee) && !authStore.user.permissions.subscription.employees);
}
